export const defaultImplementationMarketIso = 'us'

export const implementationExamplesPath = '/internal/implementation-examples'

const withQuery = (path: string, query: Record<string, string | null | undefined>) => {
  const params = new URLSearchParams(Object.entries(query).filter((entry): entry is [string, string] => !!entry[1]))
  return params.toString() ? `${path}?${params}` : path
}

const marketQuery = (marketIso?: string | null) => (marketIso && marketIso !== defaultImplementationMarketIso ? marketIso : undefined)

export const getImplementationExamplesPath = (marketIso?: string | null) => withQuery(implementationExamplesPath, { marketIso: marketQuery(marketIso) })

export const getImplementationScreenshotsPath = (gameId: string, marketIso?: string | null) =>
  withQuery(`${implementationExamplesPath}/${encodeURIComponent(gameId)}/screenshots`, { marketIso: marketQuery(marketIso) })

// One screenshot edits its comment; several get one new comment copied to each.
export const getScreenshotCommentEditPath = ({ gameId, screenshotIds, marketIso }: { gameId: string; screenshotIds: string[]; marketIso?: string | null }) => {
  const path = `${implementationExamplesPath}/${encodeURIComponent(gameId)}/comments?shotIds=${screenshotIds.map(encodeURIComponent).join(',')}`
  const market = marketQuery(marketIso)
  return market ? `${path}&marketIso=${encodeURIComponent(market)}` : path
}

export const parseScreenshotIds = (value: string | null) =>
  Array.from(
    new Set(
      (value ?? '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
    )
  )
